module.exports = __webpack_public_path__ + "static/media/logo-technasium-white-text.a0ae732e.svg";